export enum AnalysisDecisionStatus {
  Undecided = "Undecided",
  Shortlisted = "Shortlisted",
  Disqualified = "Disqualified",
  MissingEssential = "MissingEssential",
}

export enum DecisionBannerIconType {
  Cross = "Cross",
  Check = "Check",
  TriangleWarning = "TriangleWarning",
}
